import { UtmParamKey, UtmParams } from './utm-params';

export const ATTRIBUTION_COOKIE_NAME = '_ecologi_attribution';
export const UTM_SESSION_STORAGE_KEY = 'ecologi-utm-params';

export function parseAttributionCookieValue(raw: string): UtmParams | null {
  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed !== 'object' || parsed === null) return null;

    const validKeys = new Set<string>(Object.values(UtmParamKey));
    const utmParams: UtmParams = {};

    for (const [key, value] of Object.entries(parsed)) {
      if (validKeys.has(key) && typeof value === 'string') {
        utmParams[key as UtmParamKey] = value;
      }
    }

    if (Object.keys(utmParams).length === 0) return null;
    return utmParams;
  } catch {
    return null;
  }
}

export function extractUtmFromSearchParams(params: Record<string, string | string[] | undefined>): UtmParams | null {
  const utmParams: UtmParams = {};

  for (const key of Object.values(UtmParamKey)) {
    if (key === UtmParamKey.ATTRIBUTED_AT) continue;
    const value = params[key];
    const resolved = Array.isArray(value) ? value[0] : value;
    if (resolved) {
      utmParams[key] = resolved;
    }
  }

  if (Object.keys(utmParams).length === 0) return null;

  utmParams[UtmParamKey.ATTRIBUTED_AT] = new Date().toISOString();
  return utmParams;
}
